import { render, staticRenderFns } from "./SetSortingDeviceModal.vue?vue&type=template&id=2d0ccf2e&"
import script from "./SetSortingDeviceModal.vue?vue&type=script&lang=js&"
export * from "./SetSortingDeviceModal.vue?vue&type=script&lang=js&"
import style0 from "./SetSortingDeviceModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports